import script from "./SpsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpsDetail.vue?vue&type=script&lang=ts&setup=true"

import "./SpsDetail.vue?vue&type=style&index=0&id=770b239f&lang=css"
import "./SpsDetail.vue?vue&type=style&index=1&id=770b239f&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770b239f"]])

export default __exports__